var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2026_1976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0664 3.21562H1.93359C0.842052 3.21562 -0.05 4.10372 -0.05 5.19922V16.8008C-0.05 17.8967 0.842626 18.7844 1.93359 18.7844H20.0664C21.1579 18.7844 22.05 17.8963 22.05 16.8008V5.19922C22.05 4.10345 21.1575 3.21562 20.0664 3.21562ZM10.5359 12.8164L2.35094 4.60469H19.6491L11.4641 12.8164C11.3494 12.9314 11.1765 12.9913 11 12.9913C10.8235 12.9913 10.6506 12.9315 10.5359 12.8164ZM6.76423 11L1.33906 16.4428V5.55718L6.76423 11ZM2.35094 17.3953L7.74486 11.9838L9.55216 13.797C10.3268 14.5742 11.6735 14.5739 12.4479 13.797L14.2552 11.9839L19.6491 17.3953H2.35094ZM15.2358 11L20.6609 5.55718V16.4428L15.2358 11Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2026_1976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMail);
export default __webpack_public_path__ + "static/media/white-mail.4a5e5cb62f13041e7a1ebe7950f9df30.svg";
export { ForwardRef as ReactComponent };